/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Spiner from '../../../components/Spiner'
import Maintenance from '../../../functions/logic/Maintenance'
import CreateTable from '../../../components/DataTable'
import TemplatesModal from '../../../components/TemplatesModal'
import { useSnackbar } from 'notistack'


export default function TemplatesCreated() {
    const [spiner, setSpiner] = useState(false)
    const [templatesData, setTemplatesData] = useState([])
    const [isOpenHtml, setIsOpenHtml] = useState(false)
    const [bodyHtml, setBodyHtml] = useState('')
    const userToken = localStorage.getItem('userToken')
    const { enqueueSnackbar } = useSnackbar();
    const param = useParams()


    useEffect(() => {
        setSpiner(true)
        getCreatedTemplates(param)
        setSpiner(false)
    }, [param])

    const getCreatedTemplates = async (param) => {
        global.MENU_MODULE_SELECT = 'mantenimiento'
        const response = await Maintenance.templatesLogic(userToken, param.moduleId, 0)
        setTemplatesData(response["responseMapperTable"])
    }

    const handledSend = async (e) => {
        setSpiner(true)
        const response = await Maintenance.sendPromotionsLogic(userToken, param.moduleId, e)
        setSpiner(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
    }

    const exportHtml = async (e) => {
        setSpiner(true)
        const response = await Maintenance.templatesLogic(userToken, param.moduleId, e)
        setIsOpenHtml(true)
        setBodyHtml(response["responseMapper"][0]["html"])
        setSpiner(false)
    }

    const handleCloseModal = () => {
        setIsOpenHtml(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <TemplatesModal
                isOpen={isOpenHtml}
                body={bodyHtml}
                button={"cerrar"}
                handleCloseModal={handleCloseModal}
            />
            <CreateTable data={templatesData} handledSend={handledSend} title={'Templates'} handledSee={exportHtml} />
        </>
    )
}
